import { render, staticRenderFns } from "./Colaboradores.vue?vue&type=template&id=3815c10d&scoped=true"
import script from "./Colaboradores.vue?vue&type=script&lang=js"
export * from "./Colaboradores.vue?vue&type=script&lang=js"
import style0 from "./Colaboradores.vue?vue&type=style&index=0&id=3815c10d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3815c10d",
  null
  
)

export default component.exports